(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[78,2428],{

/***/ 80760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(80760),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 94640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PictureWithLinkComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82305);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PictureWithLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PictureWithLinkComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PictureWithLinkComponent);
    function PictureWithLinkComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PictureWithLinkComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onClick", function(e) {
            var _props = _this.props, href = _props.href, src = _props.src;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PictureWithLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, href = _this_props.href, target = _this_props.target, otherProps = _object_without_properties(_this_props, [
                    "href",
                    "target"
                ]);
                if (href) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: target,
                        onClick: this.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps))
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps));
            }
        }
    ]);
    return PictureWithLinkComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

PictureWithLinkComponent.defaultProps = {
    target: "_self"
};


/***/ }),

/***/ 57578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35061);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);
/* harmony import */ var constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87154);



/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonSize: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__.MD,
    buttonText: "Button",
    isOpenLinkInNewTab: false,
    onClick: null,
    color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME,
    isWithArrow: true,
    minPadding: false,
    additionalText: null,
    additionalTextPosition: constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__/* .BELOW */ ._,
    additionalTextMaxWidth: null,
    iconRenderer: null,
    extraEventData: {}
});


/***/ }),

/***/ 35662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ regular_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.scss.js

var StyledRegularButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e633rko0"
})("&.full{width:100%;}.additional-button-text{margin-top:8px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var default_props = __webpack_require__(57578);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}















var isSeoFriendlyUrl = function(url) {
    var res = false;
    if (url && url.indexOf(links/* MONDAY_AUTH_DOMAIN */.NyZ) < 0) {
        res = true;
    }
    return res;
};
var RegularButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RegularButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RegularButton);
    function RegularButton(props) {
        (0,_class_call_check/* default */.Z)(this, RegularButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var _props = _this.props, buttonText = _props.buttonText, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, onClick = _props.onClick, extraEventData = _props.extraEventData;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.REGULAR_BUTTON_CLICKED, {
                kind: buttonText,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: url,
                info3: (0,utils_url.getLastPartOfUrl)(url),
                data: extraEventData
            });
            if (onClick) {
                onClick(e);
            }
            if (url && !_this.isSeoFriendlyUrl) {
                if (isOpenLinkInNewTab) {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonBackgroundColor", function(color) {
            if (color === color_consts.DODGER_BLUE_COLOR_NAME || color === color_consts.SPACE_BLUE_COLOR_NAME) {
                return color_consts.WORK_OS_IRIS_COLOR_NAME;
            }
            return color;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonStrippedText", function() {
            var buttonText = _this.props.buttonText;
            var disallowedButtonChars = [
                /\s*>/g
            ];
            var strippedButtonText = buttonText;
            disallowedButtonChars.forEach(function(ending) {
                strippedButtonText = strippedButtonText.replace(ending, "");
            });
            return strippedButtonText;
        });
        _this.isSeoFriendlyUrl = isSeoFriendlyUrl(props.url);
        return _this;
    }
    (0,_create_class/* default */.Z)(RegularButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, buttonSize = _props.buttonSize, color = _props.color, outline = _props.outline, isWithArrow = _props.isWithArrow, iconRenderer = _props.iconRenderer, minPadding = _props.minPadding, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, additionalText = _props.additionalText, additionalTextPosition = _props.additionalTextPosition, additionalTextMaxWidth = _props.additionalTextMaxWidth, className = _props.className;
                var buttonStyle = button_service/* buttonStyles */.$Y[color] || {};
                var textColor = buttonStyle.textColor, backgroundColorName = buttonStyle.backgroundColorName;
                var buttonColor = this.getButtonBackgroundColor(backgroundColorName);
                var buttonStrippedText = this.getButtonStrippedText();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegularButton, {
                    className: classnames_default()("regular-button", buttonSize, additionalText && "additional-text additional-text-".concat(additionalTextPosition)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.ZP, {
                            seoFriendlyUrl: this.isSeoFriendlyUrl && url,
                            isOpenLinkInNewTab: isOpenLinkInNewTab,
                            size: buttonSize,
                            onClick: this.onClick,
                            color: buttonColor,
                            textColor: textColor,
                            outline: outline,
                            isWithArrow: isWithArrow,
                            className: className,
                            iconRenderer: iconRenderer,
                            minPadding: minPadding,
                            children: buttonStrippedText
                        }),
                        additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("additional-button-text", this.additionalTextPosition),
                            style: {
                                maxWidth: additionalTextMaxWidth
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                text: additionalText
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return RegularButton;
}(react.PureComponent);
RegularButton.defaultProps = default_props/* default */.Z;
/* harmony default export */ var regular_button = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(RegularButton)));


/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 5 modules
var short_footer = __webpack_require__(56914);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}












var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, setStartShowingStickyHeader = props.setStartShowingStickyHeader, isInView = props.isInView;
    (0,react.useEffect)(function() {
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 14066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    body: "monday.com, ranked #1 for productivity, helps teams manage and execute projects that deliver results on time."
});


/***/ }),

/***/ 75073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph/paragraph.scss.js

var StyledParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehzaxgp0"
})(".paragraph-body{font-size:1.125rem;line-height:32px;margin:0;//overide h3 global definition\n    word-break:break-word;&.xs{font-size:0.8125rem;line-height:20px;}&.sm{font-size:0.875rem;line-height:22px;}&.ms{font-size:1rem;line-height:24px;}&.md{font-size:1.125rem;line-height:32px;}&.lg{font-size:1.375rem;line-height:40px;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph/paragraph.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var Paragraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Paragraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Paragraph);
    function Paragraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, Paragraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getStyle", function() {
            var _props = _this.props, bodyColor = _props.bodyColor, textWidth = _props.textWidth;
            var customStyle = {
                maxWidth: textWidth
            };
            if (bodyColor && colors/* default */.Z[bodyColor]) {
                customStyle = _object_spread_props(_object_spread({}, customStyle), {
                    color: colors/* default */.Z[bodyColor]
                });
            }
            return customStyle;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Paragraph, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, body = _props.body, textSize = _props.textSize, isFirstSegment = _props.isFirstSegment, className = _props.className;
                var CustomTag = isFirstSegment ? "h2" : "div";
                var style = this.getStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParagraph, {
                    className: classnames_default()("paragraph-wrapper", className),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        tagName: CustomTag,
                        className: classnames_default()("paragraph-body", textSize),
                        text: (0,strings.encloseBoldTag)(body),
                        style: style
                    })
                });
            }
        }
    ]);
    return Paragraph;
}(react.PureComponent);

Paragraph.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 49929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DJ": function() { return /* binding */ titleLineHeights; },
/* harmony export */   "mo": function() { return /* binding */ titleFontSizes; },
/* harmony export */   "t_": function() { return /* binding */ titleFontSizeNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


var _obj;
var titleFontSizeNumber = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, 0.6875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, 0.875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, 1.125), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, 1.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, 1.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, 2.25), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, 2.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, 3.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, 4), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, 4.5), _obj);
var _obj1;
var titleLineHeights = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "40px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "48px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "60px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "68px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "72px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "85px"), _obj1);
var _obj2;
var titleFontSizes = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3], "rem") // 72px
), _obj2);


/***/ }),

/***/ 51261:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
});


/***/ }),

/***/ 91265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var react = __webpack_require__(12783);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.scss.js




var StyledTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e168hrcx0"
})(".core-title{font-size:2.25rem;font-weight:400;line-height:48px;word-break:break-word;&.xss{font-size:", consts/* titleFontSizes */.mo[sizes/* XXS */.Mp], ";line-height:32px;font-weight:400;}&.xs_m{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_M */.g4], ";line-height:32px;font-weight:400;}&.xs_ml{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_ML */.l$], ";line-height:32px;font-weight:400;}&.xs_l{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_L */.L4], ";line-height:32px;font-weight:400;}&.xs{font-size:", consts/* titleFontSizes */.mo[sizes.XS], ";line-height:32px;font-weight:400;}&.sm{font-size:", consts/* titleFontSizes */.mo[sizes.SM], ";line-height:40px;font-weight:400;}&.md{font-size:", consts/* titleFontSizes */.mo[sizes.MD], ";line-height:48px;font-weight:400;}&.lg{font-size:", consts/* titleFontSizes */.mo[sizes.LG], ";line-height:60px;font-weight:700;}&.lgr{font-size:", consts/* titleFontSizes */.mo[sizes/* LGR */.Re], ";line-height:68px;font-weight:700;}&.xl{font-size:", consts/* titleFontSizes */.mo[sizes.XL], ";line-height:72px;font-weight:700;}&.xxl{font-size:", consts/* titleFontSizes */.mo[sizes/* XXL */.T3], ";line-height:85px;font-weight:700;}}.title-and-icon-wrapper{display:flex;.icon-wrapper{margin-right:14px;display:flex;align-items:center;.picture-icon-wrapper{display:flex;height:32px;.title-icon{height:100%;}}&.xss{.picture-icon-wrapper{height:8px;}}&.xs_m{.picture-icon-wrapper{height:12px;}}&.xs{.picture-icon-wrapper{height:18px;}}&.sm{.picture-icon-wrapper{height:24px;}}&.md{.picture-icon-wrapper{height:32px;}}&.lg{.picture-icon-wrapper{height:38px;}}&.lgr{.picture-icon-wrapper{height:44px;}}&.xl{.picture-icon-wrapper{height:56px;}}&.xxl{.picture-icon-wrapper{height:62px;}}&.lgr,&.xl,&.xxl{margin-right:20px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.core-title-container .core-title{font-size:2.25rem;line-height:48px;font-weight:400;&.md,&.lg{font-size:1.75rem;line-height:40px;font-weight:700;}&.xl,&.lgr{font-size:2.25rem;line-height:48px;font-weight:700;}&.xxl{font-size:2.75rem;line-height:48px;font-weight:700;}}.title-and-icon-wrapper{.icon-wrapper{.picture-icon-wrapper{height:32px;}&.md,&.lg,&.xl{.picture-icon-wrapper{height:24px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.js









var Title = function(props) {
    var title = props.title, titleSize = props.titleSize, titleColor = props.titleColor, isFirstSegment = props.isFirstSegment, titleIcon = props.titleIcon, titleClassName = props.titleClassName;
    var getTitleStyle = function() {
        if (!titleColor) {
            return null;
        }
        var titleStyle = {
            color: colors/* default */.Z[titleColor]
        };
        return titleStyle;
    };
    var renderIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("icon-wrapper", titleSize),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: titleIcon,
                alt: "",
                className: "title-icon",
                pictureClass: "picture-icon-wrapper"
            })
        });
    };
    var titleAndIconWrapper = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "title-and-icon-wrapper",
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
        className: "core-title-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react/* ConditionalWrapper */.M, {
            condition: !!titleIcon,
            wrapper: titleAndIconWrapper,
            children: [
                titleIcon && renderIcon(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    tagName: isFirstSegment ? "h1" : "h2",
                    className: classnames_default()("core-title", titleSize, titleClassName),
                    text: (0,strings.encloseBoldTag)(title),
                    style: getTitleStyle()
                })
            ]
        })
    });
};
Title.defaultProps = default_props/* default */.Z;
/* harmony default export */ var title = (Title);


/***/ }),

/***/ 55408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LongFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.scss.js

var StyledLongFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rc6ysx0"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var LongFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongFooterComponent);
    function LongFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, LongFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLongFooterComponent, {
                    className: "long-footer-component",
                    id: element_ids/* FOOTER_ID */.D,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return LongFooterComponent;
}(react.PureComponent);

LongFooterComponent.defaultProps = {};


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ }),

/***/ 15071:
/***/ (function(module) {

"use strict";

var ProvidersKeys = {
    SOLUTIONS_DATA: "solutions_data",
    TRANSLATIONS: "translations",
    CLUSTER_CONFIG: "cluster_config",
    MANIFEST_DATA: "manifest_data",
    MONDAY_BOARD_CONFIG: "monday_board_config"
};
module.exports = ProvidersKeys;


/***/ }),

/***/ 11685:
/***/ (function(module) {

"use strict";

var getCapitilizedString = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * returns the given string, surrounded by quotes
 * @param {*} str
 */ var addQuotesIfMissing = function(str) {
    if (!str) {
        return str;
    }
    if (!str.startsWith('"')) {
        str = '"' + str;
    }
    if (!str.endsWith('"')) {
        str += '"';
    }
    return str;
};
var toCamelCase = function(str) {
    if (!str) {
        return "";
    }
    var result = str // Lower cases the string
    .toLowerCase() // Replaces any - or _ characters with a space
    .replace(/[-_]+/g, " ") // Removes any non alphanumeric characters
    .replace(/[^\w\s]/g, "") // Uppercases the first character in each group immediately following a space
    // (delimited by spaces)
    .replace(/ (.)/g, function($1) {
        return $1.toUpperCase();
    });
    // upper case first letter
    return result.substring(0, 1).toUpperCase() + result.substring(1);
};
var toKebabCase = function(str) {
    var _str_match_map, _str_match;
    return str === null || str === void 0 ? void 0 : (_str_match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str_match === void 0 ? void 0 : (_str_match_map = _str_match.map(function(x) {
        return x.toLowerCase();
    })) === null || _str_match_map === void 0 ? void 0 : _str_match_map.join("-");
};
// Returns the words count in the given text
var getWordsCount = function(text) {
    if (!text || !text.match) {
        return 0;
    }
    return text.match(/\S+/g).length;
};
// THIS IS TEMPORARY FIX FOR TEMPLATES GENERATOR
// Because historically a lot of pages contain bold tags
// With no closing tag in the end, causing the page to break
var encloseBoldTag = function(str) {
    if (!str || !str.match) {
        return str;
    }
    var openningBoldsCount = (str.replace(/ /g, "").match(/<b>/g) || []).length;
    var closingBoldsCount = (str.replace(/ /g, "").match(/<\/b>/g) || []).length;
    return openningBoldsCount > closingBoldsCount ? "".concat(str, "</b>") : str;
};
module.exports = {
    getCapitilizedString: getCapitilizedString,
    addQuotesIfMissing: addQuotesIfMissing,
    toCamelCase: toCamelCase,
    toKebabCase: toKebabCase,
    getWordsCount: getWordsCount,
    encloseBoldTag: encloseBoldTag
};


/***/ }),

/***/ 58949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["Z"] = (onClickOutsideHOC);

/***/ })

}]);